import React, { ChangeEvent } from 'react'
import { Icon } from '../Icon'

interface UITextInputProps {
  label?: string
  value?: string | number | undefined
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void
  placeholder?: string
  autoCapitalize?: string | undefined
  error?: string | undefined
  iconName: string
  inputCustomClass?: string | undefined
  readOnly?: boolean
  type?: string
}

const UITextInput: React.FC<UITextInputProps> = ({
  label,
  value,
  onChange,
  onBlur,
  placeholder,
  error,
  iconName,
  inputCustomClass,
  readOnly,
  type,
}) => {
  return (
    <div className="relative">
      <label
        className={`text-xs font-medium ${
          error ? 'text-textError' : 'text-text1'
        }`}
      >
        {label}
      </label>
      <div
        className={`w-fill h-[48px] mt-2 p-3 border rounded-xl flex items-center gap-2 ${
          error ? 'border-textError' : 'border-gray3'
        }`}
      >
        {iconName && (
          <Icon
            name={iconName}
            width={16}
            height={16}
            strokeWidth={1}
            stroke={error ? '#FF6666' : '#02698C'}
          />
        )}
        <input
          readOnly={readOnly}
          className={`w-full focus:outline-none font-semibold text-[14px] placeholder:text-sm placeholder:text-text3 text-text4 ${
            error
              ? 'placeholder-textError text-textError'
              : 'placeholder-text3 text-text4'
          } ${inputCustomClass ? inputCustomClass : 'placeholder:font-normal font-semibold'}`}
          type={type}
          // defaultValue={value}
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          placeholder={placeholder}
        />
      </div>
    </div>
  )
}

export default UITextInput
